module.exports = __webpack_public_path__ + "img/team-03.886c5b36.jpg";